module.exports = __webpack_public_path__ + "img/pixing_xc11.d6de7e83.jpg";